import { action } from 'mobx';
import AddressRepository, { IAddressRepositoryConfig } from '../AddressRepository';
import Address, { AddressId, IAddressAttributes } from '../../domain/entities/Address';
import { ADDRESS_TYPE, FIELD_TYPE } from '../../constants/Constants';
import { NOTIFICATION_GROUP } from '../../constants/Notifications';

export type IBillingAddressRepositoryConfig = IAddressRepositoryConfig;

class BillingRepository extends AddressRepository {
  constructor(props: IBillingAddressRepositoryConfig) {
    super(props);
    this.addressType = ADDRESS_TYPE.BILLING;
  }

  @action
  public async saveNewAddress(address: Address): Promise<Address> {
    try {
      const addressData = Address.toJSON(address);

      addressData[FIELD_TYPE.ZIPCODE] = addressData[FIELD_TYPE.ZIPCODE].toString().toUpperCase();

      const response: { address?: IAddressAttributes } = await this.api.createBillingAddress(addressData);

      const newAddress = Address.fromJSON(response.address);
      this.addAddress(newAddress);

      return newAddress;
    } catch (error) {
      this.handleAddressError(error, NOTIFICATION_GROUP.BILLING);
    }
  }

  @action
  public selectAddress = async (id: AddressId): Promise<void> => {
    this.notificationsCollection.clearNotifications(NOTIFICATION_GROUP.BILLING);
    try {
      await this.api.selectBillingAddress(id);
      if (this.config.jsonSchemasEnabled) {
        const address = this.getAddressById(id);
        await this.loadAddressSchema(address.attributes[FIELD_TYPE.COUNTRY_ID]);
      }
    } catch (error) {
      this.handleAddressError(error, NOTIFICATION_GROUP.BILLING);
    }
  };
}

export default BillingRepository;
